import React, { useEffect, useState } from 'react';
import './WinnersInterviews.css';

const WinnersInterviews = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  useEffect(() => {
    document.body.classList.add('editorial-white-theme');
    return () => { document.body.classList.remove('editorial-white-theme'); };
  }, []);

  return (
    <div className="ed-wrapper">
      <div className="ed-container">
        
        <header>
          <span style={{ fontWeight: 800, color: '#888', letterSpacing: '3px', fontSize: '0.8rem' }}>
            2026 COMPETITION WINNERS
          </span>
          <h1 className="ed-title">Design with <br/> Curves</h1>
        </header>

        {/* IMAGE 1 */}
        <div className="ed-hero-frame" onClick={() => setSelectedImg("/assets/design-with-curves-competition-winners-01.webp")}>
          <img src="/assets/design-with-curves-competition-winners-01.webp" className="ed-img" alt="Hero" />
        </div>

        <article style={{ maxWidth: '950px', margin: '0 auto' }}>
          
          <div className="qa-block">
            <h3 className="qa-question">Q: How does this year's theme redefine empathetic architecture?</h3>
            <p className="ed-p-light">
              The winners of this year's "Design with Curves" showcase a shift toward empathetic architecture. 
              By prioritizing the arc over the angle, these designers have created a new visual language that feels both futuristic and deeply grounded.
            </p>
          </div>

          {/* IMAGE 2 - Large & Full Width */}
          <div className="ed-portrait-frame" onClick={() => setSelectedImg("/assets/design-with-curves-competition-winners-02.webp")}>
            <img src="/assets/design-with-curves-competition-winners-02.webp" className="ed-img" alt="Sketch Detail" />
          </div>

          {/* NEW Q&A ADDED UNDER IMAGE 2 */}
          <div className="qa-block">
            <h3 className="qa-question">Q: What was the primary inspiration behind the sketched fluid forms?</h3>
            <p className="ed-p-light">
              The initial sketches were driven by the way wind moves across sand dunes. We wanted to capture 
              a moment of movement and freeze it in structural form, ensuring the building feels alive 
              even when viewed from a distance.
            </p>
          </div>

          <div className="ed-quote-wrap">
            <blockquote className="ed-main-quote">
              "The straight line is a man-made constraint; the curve is the natural freedom of form."
            </blockquote>
          </div>

          <div className="qa-block">
            <h3 className="qa-question">Q: How do these organic shapes interact with natural light?</h3>
            <p className="ed-p-light">
              The success lies in the tactile surfaces. They diffuse light softly, 
              ensuring that the curves remain visible even in the harshest midday sun.
            </p>
          </div>

          {/* CREATIVE GRID */}
          <div className="ed-creative-grid">
            <div className="ed-landscape-frame" onClick={() => setSelectedImg("/assets/design-with-curves-competition-winners-03.webp")}>
              <img src="/assets/design-with-curves-competition-winners-03.webp" className="ed-img" alt="Detail 3" />
            </div>
            <div className="ed-landscape-frame" onClick={() => setSelectedImg("/assets/design-with-curves-competition-winners-04.webp")}>
              <img src="/assets/design-with-curves-competition-winners-04.webp" className="ed-img" alt="Detail 4" />
            </div>
          </div>

        </article>

        {/* POPUP MODAL */}
        {selectedImg && (
          <div className="ed-modal-overlay" onClick={() => setSelectedImg(null)}>
            <div className="ed-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="ed-close-btn" onClick={() => setSelectedImg(null)}>&times;</button>
              <img src={selectedImg} className="ed-modal-img" alt="Expanded view" />
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default WinnersInterviews;
